'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderWithQR = undefined;

var _SliderWithQR2 = require('./SliderWithQR');

var _SliderWithQR3 = _interopRequireDefault(_SliderWithQR2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SliderWithQR = _SliderWithQR3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/SliderWithQR/index.js
// module id = 1771
// module chunks = 0